<template>
  <el-form
      ref="form"
      :model="form"
      label-width="90px"
      :class="{'info-form': viewOpType}"
      :label-suffix="viewOpType ? '' : ''">
    <el-row>
<!--      <div class="purchase-form&#45;&#45;title"></div>-->
      <gj-area-title font-size="13px">基础资料</gj-area-title>
      <el-row style="margin-bottom: 12px">
        <el-col :span="12">
          <el-form-item
              label="采购员"
              prop="buyerId">
            <template v-if="viewOpType">{{ form.buyer | defaultShow }}</template>
            <gj-creator-select
                v-else
                v-model="form.buyerId"
                placeholder="采购员"
                width="330px"
                active
            ></gj-creator-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              label="预计交期"
              prop="expectDeliveryDays"
              :rules="[
                $gjReRule(RE.pt0, '请输入大于0的整数')
              ]">
            <template v-if="viewOpType">{{ form.expectDeliveryDays | defaultShow('', '天') }}</template>
            <gj-input
                v-else
                v-model="form.expectDeliveryDays"
                width="330px"
                placeholder="预计交期（不填默认为0）"
            ></gj-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-row>
    <el-row>
<!--      <div class="purchase-form&#45;&#45;title">采购规格</div>-->
      <gj-area-title font-size="13px">采购规格</gj-area-title>
      <div>
        <el-form-item
            label="产品材质"
            prop="material">
          <template v-if="viewOpType">{{ form.material | defaultShow }}</template>
          <gj-input
              v-else
              v-model="form.material"
              width="330px"
              placeholder="产品材质"></gj-input>
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item
              label="单品尺寸"
              class="gj-union--input">
            <template v-if="viewOpType">
              {{ form.singleProductSizeL | defaultShow }} cm * {{ form.singleProductSizeW | defaultShow }} cm * {{ form.singleProductSizeH | defaultShow }} cm
            </template>
            <template v-else>
              <el-form-item
                  prop="singleProductSizeL"
                  class="no-border"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.singleProductSizeL"
                    width="110px"
                    placeholder="长">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
              <el-form-item
                  prop="singleProductSizeW"
                  class="no-left_padding no-border"
                  :rules="[
                  $gjReRule(RE.num(4), '最多4位小数的正数')
                ]">
                <gj-input
                    v-model="form.singleProductSizeW"
                    width="110px"
                    placeholder="宽">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
              <el-form-item
                  prop="singleProductSizeH"
                  class="no-left_padding"
                  :rules="[
                  $gjReRule(RE.num(4), '最多4位小数的正数')
                ]">
                <gj-input
                    v-model="form.singleProductSizeH"
                    width="110px"
                    placeholder="高">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              label="单品净重"
              prop="unitNetWeight"
              :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
            <template v-if="viewOpType">{{ form.singleProductNetWeight | defaultShow('', 'g') }}</template>
            <gj-input
                v-else
                v-model="form.singleProductNetWeight"
                width="330px"
                placeholder="单品净重">
              <template #append>g</template>
            </gj-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
              class="gj-union--input">
            <template #label>
              包装尺寸
              <gj-tooltip content="用于计算体积重">
                <i class="el-icon-question"></i>
              </gj-tooltip>
            </template>
            <template v-if="viewOpType">
              {{ form.packageL | defaultShow }} cm * {{ form.packageW | defaultShow }} cm * {{ form.packageH | defaultShow }} cm
            </template>
            <template v-else>
              <el-form-item
                  prop="packageL"
                  class="no-border"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.packageL"
                    width="110px"
                    placeholder="长">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
              <el-form-item
                  prop="packageW"
                  class="no-left_padding no-border"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.packageW"
                    width="110px"
                    placeholder="宽">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
              <el-form-item
                  prop="packageH"
                  class="no-left_padding"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.packageH"
                    width="110px"
                    placeholder="高">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              prop="packageWeight"
              :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
            <template #label>
              单品毛重
              <gj-tooltip content="用于计算体积重">
                <i class="el-icon-question"></i>
              </gj-tooltip>
            </template>
            <template v-if="viewOpType">{{ form.packageWeight | defaultShow('', 'g') }}</template>
            <gj-input
                v-else
                v-model="form.packageWeight"
                width="330px"
                placeholder="单品毛重">
              <template #append>g</template>
            </gj-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
              label="箱规"
              class="gj-union--input">
            <template v-if="viewOpType">
              {{ form.cartonSizeL | defaultShow }} cm * {{ form.cartonSizeW | defaultShow }} cm * {{ form.cartonSizeH | defaultShow }} cm
            </template>
            <template v-else>
              <el-form-item
                  prop="cartonSizeL"
                  class="no-border"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.cartonSizeL"
                    width="110px"
                    placeholder="长">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
              <el-form-item
                  prop="cartonSizeW"
                  class="no-left_padding no-border"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.cartonSizeW"
                    width="110px"
                    placeholder="宽">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
              <el-form-item
                  prop="cartonSizeH"
                  class="no-left_padding"
                  :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
                <gj-input
                    v-model="form.cartonSizeH"
                    width="110px"
                    placeholder="高">
                  <template #append>cm</template>
                </gj-input>
              </el-form-item>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              label="单箱净重"
              prop="singleNetWeight"
              :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]">
            <template v-if="viewOpType">{{ form.singleNetWeight | defaultShow('', 'kg') }}</template>
            <gj-input
                v-else
                v-model="form.singleNetWeight"
                width="330px"
                placeholder="单箱净重">
              <template #append>kg</template>
            </gj-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
              label="单箱毛重"
              prop="singleWeight"
              :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]"
              style="margin-bottom: 10px;"
          >
            <template v-if="viewOpType">{{ form.singleWeight | defaultShow('', 'kg') }}</template>
            <gj-input
                v-else
                v-model="form.singleWeight"
                width="330px"
                placeholder="单箱毛重">
              <template #append>kg</template>
            </gj-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              label="单箱数量"
              prop="singleQuantity"
              :rules="[ $gjReRule(RE.num(4), '最多4位小数的正数') ]"
              style="margin-bottom: 10px;"
          >
            <template v-if="viewOpType">{{ form.singleQuantity | defaultShow }}</template>
            <gj-input
                v-else
                v-model="form.singleQuantity"
                width="330px"
                placeholder="单箱数量"
            ></gj-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-row>
  </el-form>
</template>

<script>
  import {formRuleMixin, formValidatorMixin, opTypeMixin} from "../../../../../../minxins";

  export default {
    name: "app-product-purchase-form",
    mixins: [formValidatorMixin, formRuleMixin, opTypeMixin],
    props: {
      form: {
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .form-input {
    width: 180px !important;
  }
  .purchase-form--title {
    color: #303133;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .purchase-form--label {
    width: 90px;
    display: inline-block;
    text-align: right;
    vertical-align: middle;
    color: #888;
    font-size: 14px;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  .info-form{
    /deep/ .el-form-item__label, /deep/.el-form-item__content{
      line-height: 20px;
    }
    /deep/ .el-form-item{
      margin-bottom: 12px;
    }
    /deep/ .gj-area-title{
      // margin-bottom: 24px;
    }
  }
  .no-left_padding{
    /deep/ .el-input__inner{
      border-left-color: rgba($color: #000000, $alpha: 0);
      &:focus, &:hover{
        border-left-color:#1F6EEF;
      }
    }
    
  }
  .no-border{
    /deep/ .el-input-group__append{
      border-radius: 0;
    }
  }
  
  
</style>
